export default {
  name: "Undo",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M24.4 9.91a11 11 0 0 0-12.25-3.28l1-2.3a1 1 0 1 0-1.84-.8L9.11 8.6a1 1 0 0 0 .63 1.35l5.03 1.53a1 1 0 0 0 .58-1.92l-2.93-.89a9 9 0 1 1-4.77 4.8 1 1 0 0 0-1.84-.78 10.97 10.97 0 0 0 10.14 15.26A11.02 11.02 0 0 0 24.4 9.91z",
  },
}
